import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouteReuseStrategy } from "@angular/router";
import { CustomRouteData } from "@modules/common/models/custom-route-data";

@Injectable({
    providedIn: 'root'
})
export class StingrayRouteReuseStrategy implements RouteReuseStrategy {
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }

    store(route: ActivatedRouteSnapshot, handle: {} | null): void {
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }

    retrieve(route: ActivatedRouteSnapshot): {} | null {
        return null;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        while (future.firstChild) {
            future = future.firstChild;
        }

        while (curr.firstChild) {
            curr = curr.firstChild;
        }

        if (future.routeConfig?.data && curr.routeConfig && future.routeConfig.data == curr.routeConfig.data) {
            const nonReuseProperties = (<CustomRouteData>future.routeConfig.data).allowRouteReuse;
            if (nonReuseProperties) {
                for (let i = 0; i < nonReuseProperties.length; i++) {
                    if (curr.params[nonReuseProperties[i]] != 'NEW-RECORD' && future.params[nonReuseProperties[i]] != curr.params[nonReuseProperties[i]]) {
                        break;
                    }
                }
                return true;
            }
        }

        window.scroll(0, 0);
        return false;
    }
}
